/* GameEditorCabinetRenderer.js */

'use strict';
const _ = require('lodash');

class GameEditorCabinetRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('game-editor-cabinet-gl');
    this._rootElem.component = this._model;
    this._logger = this._model.logger;

    // TODO: REMOVE ONCE WE REVISIT PINNING
    this._rootElem.classList.add('views-expanded');
    this._rootElem.classList.add('actions-expanded');

    this._viewsLocalStorageKey = 'GameEditorCabinetComponentViewsPinned';
    this._actionsLocalStorageKey = 'GameEditorCabinetComponentActionsPinned';
    this._viewsPinned = false;
    this._actionsPinned = false;

    this._viewGroupElem = document.createElement('game-editor-view-group');
    this._viewGroupElem.tabIndex = -1;
    this._viewHandleElem = document.createElement('game-editor-view-handle');
    this._viewIconElem = document.createElement('game-editor-actionable-icon-gl');
    this._viewIconElem.dataset.icon = 'game_editor.views';
    this._viewIconElem.setAttribute('title', 'Views');
    this._viewPinIconElem = document.createElement('game-editor-toggle-icon-gl');
    this._viewPinIconElem.dataset.icon = 'toggle.pin';
    this._viewPinIconElem.setAttribute('title', 'Pin');
    this._viewPinIconElem.classList.add('pin-icon');
    this._viewHandleElem.appendChild(this._viewIconElem);
    //this._viewHandleElem.appendChild(this._viewPinIconElem);
    this._viewContentsElem = document.createElement('game-editor-view-contents');
    this._viewGroupElem.appendChild(this._viewContentsElem);
    this._viewGroupElem.appendChild(this._viewHandleElem);
    this._viewContentsElemArr = [];

    this._actionGroupElem = document.createElement('game-editor-action-group');
    this._actionGroupElem.tabIndex = -1;
    this._actionHandleElem = document.createElement('game-editor-action-handle');
    this._actionIconElem = document.createElement('game-editor-actionable-icon-gl');
    this._actionIconElem.dataset.icon = 'game_editor.actions';
    this._actionIconElem.setAttribute('title', 'Actions');
    this._actionPinIconElem = document.createElement('game-editor-toggle-icon-gl');
    this._actionPinIconElem.dataset.icon = 'toggle.pin';
    this._actionPinIconElem.setAttribute('title', 'Pin');
    this._actionPinIconElem.classList.add('pin-icon');
    this._actionHandleElem.appendChild(this._actionIconElem);
    //this._actionHandleElem.appendChild(this._actionPinIconElem);
    this._actionContentsElem = document.createElement('game-editor-action-contents');
    this._actionGroupElem.appendChild(this._actionContentsElem);
    this._actionGroupElem.appendChild(this._actionHandleElem);
    this._actionContentsElemArr = [];

    this._registerListeners();
  }
  /********************************************/
  /* START PRIVATE COMPONENT RENDERER METHODS */
  /********************************************/
  _registerListeners() {
    this.model.on('ActionsRegistered', (this._renderActions = this._renderActions.bind(this)));
    this.model.on('ActionAdded', (this._addAction = this._addAction.bind(this)));
    this.model.on('ViewsRegistered', (this._renderViews = this._renderViews.bind(this)));
    this.model.on('ViewAdded', (this._addView = this._addView.bind(this)));
    this.model.on('ViewSelected', (this._onViewSelected = this._onViewSelected.bind(this)));
    this.model.on('EnableAction', (this._onEnableAction = this._onEnableAction.bind(this)));
    this.model.on('DisableAction', (this._onDisableAction = this._onDisableAction.bind(this)));
    this.model.on('HideAction', (this._onHideAction = this._onHideAction.bind(this)));
    this.model.on('ShowAction', (this._onShowAction = this._onShowAction.bind(this)));
    this.model.on('HideView', (this._onHideView = this._onHideView.bind(this)));
    this.model.on(
      'DisableAllActions',
      (this._onDisableAllActions = this._onDisableAllActions.bind(this))
    );
    this.model.on(
      'EnableAllActions',
      (this._onEnableAllActions = this._onEnableAllActions.bind(this))
    );
    this.model.on('RetardActions', (this._onRetardedActions = this._onRetardedActions.bind(this)));
    this.model.on('Show', (this._onShow = this._onShow.bind(this)));
    this.model.on('Hide', (this._onHide = this._onHide.bind(this)));

    this._viewPinIconElem.addEventListener(
      'click',
      (this._onViewPinIconClick = this._onViewPinIconClick.bind(this))
    );
    //this._viewIconElem.addEventListener('click', this._onViewIconClick = this._onViewIconClick.bind(this));
    this._viewHandleElem.addEventListener(
      'mouseenter',
      (this._onViewHandleMouseEnter = this._onViewHandleMouseEnter.bind(this))
    );
    //this._viewGroupElem.addEventListener('mouseleave', this._onViewGroupMouseLeave = this._onViewGroupMouseLeave.bind(this));
    this._viewGroupElem.addEventListener(
      'blur',
      (this._onViewGroupBlur = this._onViewGroupBlur.bind(this))
    );
    this._actionPinIconElem.addEventListener(
      'click',
      (this._onActionPinIconClick = this._onActionPinIconClick.bind(this))
    );
    //this._actionIconElem.addEventListener('click', this._onActionIconClick = this._onActionIconClick.bind(this));
    this._actionHandleElem.addEventListener(
      'mouseenter',
      (this._onActionHandleMouseEnter = this._onActionHandleMouseEnter.bind(this))
    );
    //this._actionGroupElem.addEventListener('mouseleave', this._onActionGroupMouseLeave = this._onActionGroupMouseLeave.bind(this));
    this._actionGroupElem.addEventListener(
      'blur',
      (this._onActionGroupBlur = this._onActionGroupBlur.bind(this))
    );
  }
  _unregisterListeners() {
    this.model.removeAllListeners('ActionsRegistered');
    this.model.removeAllListeners('ActionAdded');
    this.model.removeAllListeners('ViewsRegistered');
    this.model.removeAllListeners('ViewAdded');
    this.model.removeAllListeners('ViewSelected');
    this.model.removeAllListeners('EnableAction');
    this.model.removeAllListeners('DisableAction');
    this.model.removeAllListeners('HideAction');
    this.model.removeAllListeners('ShowAction');
    this.model.removeAllListeners('HideView');
    this.model.removeAllListeners('DisableAllActions');
    this.model.removeAllListeners('EnableAllActions');
    this.model.removeAllListeners('RetardActions');
    this.model.removeAllListeners('Show');
    this.model.removeAllListeners('Hide');

    this._viewPinIconElem.removeEventListener('click', this._onViewPinIconClick);
    this._viewIconElem.removeEventListener('click', this._onViewIconClick);
    this._viewHandleElem.removeEventListener('mouseenter', this._onViewHandleMouseEnter);
    this._viewGroupElem.removeEventListener('mouseleave', this._onViewGroupMouseLeave);
    this._actionPinIconElem.removeEventListener('click', this._onActionPinIconClick);
    this._actionIconElem.removeEventListener('click', this._onActionIconClick);
    this._actionHandleElem.removeEventListener('mouseenter', this._onActionHandleMouseEnter);
    this._actionGroupElem.removeEventListener('mouseleave', this._onActionGroupMouseLeave);
    this._actionGroupElem.removeEventListener('blur', this._onActionGroupBlur);
  }
  _onEnableAllActions() {
    let childrenLength = this._actionContentsElem.children.length;
    for (let i = 0; i < childrenLength; i++) {
      let childElem = this._actionContentsElem.childNodes[i];
      childElem.disabled = false;
    }
  }
  _onDisableAllActions() {
    let childrenLength = this._actionContentsElem.children.length;
    for (let i = 0; i < childrenLength; i++) {
      let childElem = this._actionContentsElem.childNodes[i];
      childElem.disabled = true;
    }
  }
  _onShow() {
    if (_.get(this, '_rootElem.style.display') === 'none') {
      this._rootElem.style.display = '';
    }
  }
  _onHide() {
    if (_.get(this, '_rootElem.style.display') === '') {
      this._rootElem.style.display = 'none';
    }
  }
  _onEnableAction(fqn) {
    let childrenLength = this._actionContentsElem.children.length;

    for (let i = 0; i < childrenLength; i++) {
      let childElem = this._actionContentsElem.childNodes[i];
      if (childElem.value === fqn) {
        childElem.disabled = false;
      }
    }
  }
  _onDisableAction(fqn) {
    let childrenLength = this._actionContentsElem.children.length;

    for (let i = 0; i < childrenLength; i++) {
      let childElem = this._actionContentsElem.childNodes[i];
      if (childElem.value === fqn) {
        childElem.disabled = true;
      }
    }
  }

  _onHideAction(fqn) {
    this._toggleActionVisibility(fqn, false);
  }

  _onShowAction(fqn) {
    this._toggleActionVisibility(fqn, true);
  }

  _onHideView(fqn) {
    let childrenLength = this._viewContentsElemArr.length;

    for (let i = 0; i < childrenLength; i++) {
      let childElem = this._viewContentsElemArr[i];
      if (childElem.value === fqn) {
        childElem.style.display = 'none';
      }
    }
  }

  _onViewSelected(fqn) {
    let childrenLength = this._viewContentsElem.children.length;

    for (let i = 0; i < childrenLength; i++) {
      let childElem = this._viewContentsElem.childNodes[i];
      if (childElem.value === fqn) {
        childElem.active = true;
      } else {
        childElem.active = false;
      }
    }
  }
  _onRequestView(viewName) {
    this.model.selectView(viewName);
  }
  _onRequestAction(actionName) {
    this.model.selectAction(actionName);
  }
  _addView(vDef) {
    if (vDef.shown) {
      let icon = vDef.icon || 'common.poo';
      let iconElem = document.createElement('game-editor-actionable-icon-gl');
      iconElem.classList.add('dark');
      iconElem.dataset.icon = icon;
      if (vDef.title) {
        iconElem.setAttribute('title', vDef.title);
      }
      iconElem.value = vDef.fullyQualifiedName;

      iconElem.addEventListener('click', () => {
        this._onRequestView(vDef.fullyQualifiedName);
      });
      this._viewContentsElem.appendChild(iconElem);
      this._viewContentsElemArr.push(iconElem);
    }
  }
  _addAction(aDef) {
    if (aDef.shown) {
      let icon = aDef.icon || 'common.bomb';
      let iconElem = document.createElement('game-editor-actionable-icon-gl');
      iconElem.classList.add('dark', 'action');
      iconElem.dataset.icon = icon;
      if (aDef.title) {
        iconElem.setAttribute('title', aDef.title);
      }
      iconElem.value = aDef.fullyQualifiedName;
      iconElem.addEventListener('click', () => {
        this._onRequestAction(aDef.fullyQualifiedName);
      });
      this._actionContentsElem.appendChild(iconElem);
      this._actionContentsElemArr.push(iconElem);
    }
  }
  _clearViews() {
    if (this._viewContentsElemArr.length > 0) {
      this._viewContentsElemArr.forEach((elem) => {
        elem.remove();
      });
    }
    this._viewContentsElemArr = [];
  }
  _clearActions() {
    if (this._actionContentsElemArr.length > 0) {
      this._actionContentsElemArr.forEach((elem) => {
        elem.remove();
      });
    }
    this._actionContentsElemArr = [];
  }
  _renderActions() {
    let shownActions = 0;
    this._clearActions();
    this._setActionsPinned(this._actionsPinned);
    let regActions = this.model.registeredActions;
    if (regActions.length > 0) {
      regActions.forEach((actionDef) => {
        if (actionDef.shown) {
          shownActions++;
        }
        this._addAction(actionDef);
      });
      if (shownActions === 0) {
        this._rootElem.classList.remove('actions-shown');
      } else {
        this._rootElem.classList.add('actions-shown');
      }
      return Promise.resolve();
    } else {
      this._rootElem.classList.remove('actions-shown');
      return Promise.resolve();
    }
  }

  _renderViews() {
    this._clearViews();
    this._setViewsPinned(this._viewsPinned);
    let regViews = this.model.registeredViews,
      shownCount = 0;
    regViews.forEach((viewDef) => {
      if (viewDef.shown === true) {
        shownCount++;
      }
    });
    if (regViews.length > 1) {
      if (shownCount > 0) {
        this._rootElem.classList.add('views-shown');
      }
      regViews.forEach((viewDef) => {
        this._addView(viewDef);
      });

      if (this._model._selectedView) {
        //reset selected view, to make it active
        this._model.setSelectedView(this._model._selectedView);
      }
      return Promise.resolve();
    } else if (regViews.length === 1) {
      this._rootElem.classList.remove('views-shown');
      this._onRequestView(regViews[0].fullyQualifiedName);
      return Promise.resolve();
    } else {
      this._rootElem.classList.remove('views-shown');
      return Promise.resolve();
    }
  }
  /*******************************************/
  /* END PRIVATE COMPONENT RENDERER METHODS  */
  /* START PUBLIC COMPONENT RENDERER METHODS */
  /*******************************************/
  shutdown() {
    this._unregisterListeners();
    let promArr = [Promise.resolve()];

    return Promise.all(promArr).then(
      () => {
        this._clearViews();
        this._clearActions();

        this._viewsLocalStorageKey = undefined;
        this._actionsLocalStorageKey = undefined;
        this._viewsPinned = undefined;
        this._actionsPinned = undefined;

        this._viewIconElem.remove();
        this._viewIconElem = undefined;
        this._viewPinIconElem = undefined;

        this._viewContentsElem.remove();
        this._viewContentsElem = undefined;

        this._viewHandleElem.remove();
        this._viewHandleElem = undefined;

        this._viewGroupElem.remove();
        this._viewContentsElemArr = undefined;

        this._actionIconElem.remove();
        this._actionIconElem = undefined;
        this._actionPinIconElem = undefined;

        this._actionHandleElem.remove();
        this._actionHandleElem = undefined;

        this._actionContentsElem.remove();
        this._actionContentsElem = undefined;

        this._actionGroupElem.remove();
        this._actionContentsElemArr = undefined;

        this._logger = undefined;
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
      },
      (err) => {
        this._logger.warn(err, 'GameEditorCabinetRenderer.shutdown() error');
      }
    );
  }
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    return new Promise((resolve /*,reject*/) => {
      if (!this._rootElem.hasChildNodes()) {
        this._rootElem.appendChild(this._viewGroupElem);
        this._rootElem.appendChild(this._actionGroupElem);
      }
      this._renderActions();
      this._renderViews();
      resolve();
    });
  }
  get rootElement() {
    return this.getRootElement();
  }
  getRootElement() {
    return this._rootElem;
  }
  get model() {
    return this.getModel();
  }
  getModel() {
    return this._model;
  }
  /*******************************************/
  /* END COMPONENT RENDERER METHODS */
  /* START PRIVATE RENDER METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE RENDER METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  _onViewPinIconClick(event) {
    this._viewsPinned = !this._viewsPinned;
    this._model._triggerUserViewsPinned({
      event: event,
      pinned: this._viewsPinned,
    });
    this._setViewsPinned(this._viewsPinned);
  }

  _onViewIconClick(/*event*/) {
    this._rootElem.classList.add('view-handle-expanded');
  }

  _onViewHandleMouseEnter(/*event*/) {
    this._rootElem.classList.add('views-expanded');
  }

  _onViewGroupMouseLeave(/*event*/) {
    this._rootElem.classList.remove('views-expanded');
  }

  _onViewGroupBlur(/*event*/) {
    this._rootElem.classList.remove('view-handle-expanded');
  }

  _onActionPinIconClick(event) {
    this._actionsPinned = !this._actionsPinned;
    this._model._triggerUserActionsPinned({
      event: event,
      pinned: this._actionsPinned,
    });
    this._setActionsPinned(this._actionsPinned);
  }

  _onActionIconClick(/*event*/) {
    this._rootElem.classList.add('action-handle-expanded');
  }

  _onActionHandleMouseEnter(/*event*/) {
    this._rootElem.classList.add('actions-expanded');
  }

  _onActionGroupMouseLeave(/*event*/) {
    this._rootElem.classList.remove('actions-expanded');
  }

  _onActionGroupBlur(/*event*/) {
    this._rootElem.classList.remove('action-handle-expanded');
  }

  _onRetardedActions(retarded) {
    if (retarded) {
      this._rootElem.classList.remove('actions-expanded');
      this._actionGroupElem.addEventListener(
        'mouseleave',
        (this._onActionGroupMouseLeave = this._onActionGroupMouseLeave.bind(this))
      );
    } else {
      this._rootElem.classList.add('actions-expanded');
    }
  }

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE API METHODS */
  /*******************************************/

  _setViewsPinned(pinned) {
    if (pinned === true) {
      this._rootElem.classList.add('views-pinned');
      this._viewPinIconElem.setToggled(true);
    } else {
      this._rootElem.classList.remove('views-pinned');
      this._viewPinIconElem.setToggled(false);
    }
  }

  _setActionsPinned(pinned) {
    if (pinned === true) {
      this._rootElem.classList.add('actions-pinned');
      this._actionPinIconElem.setToggled(true);
    } else {
      this._rootElem.classList.remove('actions-pinned');
      this._actionPinIconElem.setToggled(false);
    }
  }

  _toggleActionVisibility(fqn, state) {
    let childrenLength = this._actionContentsElem.children.length;
    for (let i = 0; i < childrenLength; i++) {
      let childElem = this._actionContentsElem.childNodes[i];
      if (childElem.value === fqn) {
        childElem.classList.toggle('hidden', !state);
      }
    }
  }

  /*******************************************/
  /*  END PRIVATE API METHODS */
  /*******************************************/
}
module.exports = GameEditorCabinetRenderer;
